import { Wallet, Banknote, Calendar, Clock, DollarSign, Text } from 'lucide-react';

const HeaderUang = ({ item }) => {

  // Menentukan jenis berdasarkan absen_id
  const getJenisInfo = () => {
    switch (item.absen_id) {
      case 'kasbon': return 'Kasbon';
      case 'cicilan': return 'Cicilan';
      case 'lembur': return 'Lembur';
      case 'piket_harian': return 'Piket Harian';
      case 'piket_perconnote': return 'Piket Perconnote';
      default: return `Pengajuan ${item.absen_id}`;
    }
  };

  // Parsing payload jika ada informasi tambahan spesifik seperti nominal, catatan_tambahan, jumlah dll
  let parsedPayload = {};
  if (item.payload) {
    try {
      if (typeof item.payload === 'string') {
        parsedPayload = JSON.parse(item.payload);
      } else if (typeof item.payload === 'object') {
        parsedPayload = item.payload;
      }
    } catch (e) {
      console.warn('Gagal parse payload HeaderUang', e);
    }
  }

  // Coba ambil nominal dari item langsung atau dari dalam payload
  const nominalValue = item.nominal || parsedPayload.nominal;
  const formattedNominal = nominalValue
    ? new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(nominalValue)
    : null;

  const getTanggalPelaksanaan = () => {
    const jenisDenganTanggal = ['lembur', 'piket_harian', 'piket_perconnote'];
    if (!jenisDenganTanggal.includes(item.absen_id)) return null;

    try {
      const stored = JSON.parse(localStorage.getItem('uang_pengajuanKasbon') || '[]');
      const list = Array.isArray(stored) ? stored : [];
      const pengajuan = list.find(data => String(data.id) === String(item.id));
      return pengajuan?.tanggal || item.tanggal || null;
    } catch (error) {
      console.warn('Gagal membaca tanggal pelaksanaan dari uang_pengajuanKasbon', error);
      return item.tanggal || null;
    }
  };

  const tanggalPelaksanaan = getTanggalPelaksanaan();
  const formattedTanggalPelaksanaan = tanggalPelaksanaan
    ? new Date(`${String(tanggalPelaksanaan).substring(0, 10)}T00:00:00`).toLocaleDateString('id-ID', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      })
    : null;
  const durasiValue =
    item.durasi ||
    item.catatan_tambahan ||
    parsedPayload.durasi ||
    parsedPayload.catatan_tambahan;

  const detailRowStyle = {
    display: 'grid',
    gridTemplateColumns: '76px 12px minmax(0, 1fr)',
    alignItems: 'start',
    fontSize: 13,
  };

  // Render detail opsional berdasarkan jenis (contoh: Shift, Jumlah Connote, dsb)
  return (
    <>
      <div style={{ marginBottom: 12, display: 'flex', flexDirection: 'row', gap: 12 }}>
        <div style={{
          width: 44,
          height: 44,
          borderRadius: 12,
          backgroundColor: ['kasbon', 'cicilan'].includes(item.absen_id) ? '#fff1f0' : '#f6ffed',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}>
          {['kasbon', 'cicilan'].includes(item.absen_id) ? (
            <Wallet size={24} color="#ff4d4f" />
          ) : (
            <Banknote size={24} color="#52c41a" />
          )}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, justifyContent: 'center' }}>
          <h3
            style={{
              margin: 0,
              fontSize: 16,
              fontWeight: 600,
              color: '#1f2937'
            }}
          >
            Pengajuan {getJenisInfo()}
          </h3>
          <div style={{ fontSize: 13, color: '#6b7280', display: 'flex', alignItems: 'center', gap: 4 }}>
            <Calendar size={13} />
            {(() => {
              const rawDate = item.created_at || item.tanggal;
              if (!rawDate) return '-';
              const d = new Date(rawDate);
              const datePart = d.toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' });
              const timePart = d.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' }).replace(/\./g, ':');
              return `${datePart} ${timePart}`;
            })()}
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 4, padding: '10px 12px', backgroundColor: '#f9fafb', borderRadius: 8 }}>

        {/* Tanggal pelaksanaan, berbeda dari waktu pengajuan di header */}
        {formattedTanggalPelaksanaan && (
          <div style={detailRowStyle}>
            <span style={{ color: '#6b7280' }}>Tanggal</span>
            <span style={{ color: '#6b7280' }}>:</span>
            <span style={{ fontWeight: 600, color: '#374151', textAlign: 'right' }}>
              {formattedTanggalPelaksanaan}
            </span>
          </div>
        )}

        {/* Durasi ditampilkan tepat di bawah tanggal */}
        {durasiValue && (
          <div style={detailRowStyle}>
            <span style={{ color: '#6b7280' }}>Durasi</span>
            <span style={{ color: '#6b7280' }}>:</span>
            <span style={{ fontWeight: 500, color: '#374151', textAlign: 'right' }}>
              {durasiValue}
            </span>
          </div>
        )}

        {/* Nominal if exists */}
        {formattedNominal && (
          <div style={detailRowStyle}>
            <span style={{ color: '#6b7280' }}>Nominal</span>
            <span style={{ color: '#6b7280' }}>:</span>
            <span style={{ fontWeight: 600, textAlign: 'right', color: ['kasbon', 'cicilan'].includes(item.absen_id) ? '#dc2626' : '#16a34a' }}>
              {formattedNominal}
            </span>
          </div>
        )}

        {/* Keterangan / Nama */}
        {item.nama && (
          <div style={{ ...detailRowStyle, marginTop: 4, borderTop: '1px solid #e5e7eb', paddingTop: 6 }}>
            <span style={{ color: '#6b7280' }}>Keterangan</span>
            <span style={{ color: '#6b7280' }}>:</span>
            <span style={{ fontWeight: 500, color: '#374151', textAlign: 'right' }}>
              {item.nama}
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default HeaderUang;
